module.exports = __webpack_public_path__ + "static/media/DSC_0080.ccc44207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0080.jpg
// module id = 554
// module chunks = 0